{
	"title": "¿Olvidaste tu contraseña?",
	"subtitle": "Ingresa el correo electrónico registrado en tu cuenta.",
	"description": "Te enviaremos un enlace para restablecer tu contraseña",
	"labels": {
		"company": "Compañía",
		"email": "Correo electrónico"
	},
	"fields": {
		"organization": {
			"placeholder": "Ingresa la compañía",
			"required": "La compañía es requerida"
		},
		"email": {
			"placeholder": "Ingresa tu correo electrónico",
			"required": "El correo electrónico es requerido",
			"invalid": "Correo electrónico inválido"
		}
	},
	"submit": "Enviar",
	"submitWait": "Espere {{time}}",
	"back": "Volver",
	"successModal": {
		"title": "Solicitud enviada!",
		"subtitle": "Si los datos proporcionados son correctos, enviaremos un enlace de restablecimiento a la dirección de correo electrónico registrada.",
		"btnTitle": "Comprendido"
	}
}
